import React from "react"

export const SiteLaunchPendingImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="400"
      height="400"
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M95.6328 153.952H125.664V165.316H95.6328V153.952Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M124.123 178.322H114.656L118.486 165.249H127.953L124.123 178.322Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M104.516 152.176L97.6406 154.99L110.941 114.869L117.817 112.051L104.516 152.176Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M103.178 156.457L109.285 137.946L104.26 137.449C102.04 137.228 99.9576 138.557 99.2225 140.663L93.7109 156.457H103.178Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M95.4618 145.629L89.9934 161.584C89.7034 162.429 89.8398 163.363 90.3594 164.09C90.8791 164.818 91.718 165.249 92.612 165.249H99.715C100.911 165.248 101.971 164.48 102.345 163.344L107.418 147.895C107.683 147.087 107.561 146.201 107.088 145.494C106.616 144.787 105.844 144.337 104.995 144.273L98.2842 143.767C97.0295 143.674 95.87 144.439 95.4618 145.629Z"
        fill="white"
        stroke="#1D2B47"
      />
      <circle
        cx="123.448"
        cy="162.544"
        r="9.67456"
        fill="white"
        stroke="#1D2B47"
      />
      <circle
        cx="123.444"
        cy="162.544"
        r="4.14736"
        fill="white"
        stroke="#1D2B47"
      />
      <circle
        cx="97.5298"
        cy="158.26"
        r="1.8032"
        fill="white"
        stroke="#1D2B47"
      />
      <rect
        x="105.641"
        y="184.441"
        width="25.6956"
        height="7.36568"
        rx="3.68284"
        fill="white"
        stroke="#1D2B47"
      />
      <rect
        x="101.586"
        y="178.322"
        width="33.81"
        height="9.69416"
        rx="4.84708"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M131.336 188.013L146.212 354.134L131.336 188.013Z"
        fill="white"
      />
      <path d="M131.336 188.013L146.212 354.134" stroke="#1D2B47" />
      <path
        d="M106.095 188.013L91.2188 354.134L106.095 188.013Z"
        fill="white"
      />
      <path d="M106.095 188.013L91.2188 354.134" stroke="#1D2B47" />
      <path d="M117.173 191.811V351.88V191.811Z" fill="white" />
      <path d="M117.173 191.811V351.88" stroke="#1D2B47" />
      <path
        d="M171.631 178.973L137.703 139.73L150.612 125.912L192.293 164.348L220.635 112.023L237.738 140.659L213.292 178.173C209.085 184.631 202.135 188.789 194.455 189.441C186.775 190.094 179.223 187.169 173.987 181.513L171.631 178.973Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M145.455 154.661L143.945 146.939L159.947 134.536L167.912 136.849C168.902 137.136 169.785 137.711 170.448 138.499L192.197 164.34L220.617 112.023L237.72 140.659L213.835 180.349C204.948 193.995 185.219 196.358 174.165 184.406L146.901 157.358C146.159 156.625 145.655 155.685 145.455 154.661Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M136.84 134.536L118.526 132.674C117.454 132.569 116.668 131.618 116.766 130.546C116.85 129.543 117.681 128.767 118.687 128.75L136.609 128.421L136.84 134.536Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M134.319 131.694L129.341 130.161L126.949 129.424L116.726 126.288C115.696 125.975 115.112 124.89 115.417 123.858C115.692 122.876 116.674 122.27 117.675 122.462L135.315 125.649L134.319 131.694Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M128.604 129.934L126.949 129.424L116.726 126.288C115.696 125.975 115.112 124.89 115.417 123.858C115.692 122.876 116.674 122.27 117.675 122.462L135.315 125.649L134.342 131.694"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M133.752 127.288L116.872 119.954C115.884 119.528 115.424 118.385 115.841 117.394C116.227 116.463 117.256 115.976 118.221 116.269L135.394 121.392L133.752 127.288Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M129.173 125.297L116.872 119.954C115.884 119.528 115.424 118.385 115.841 117.394C116.227 116.463 117.256 115.976 118.221 116.269L135.394 121.392L133.76 127.272"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M134.876 123.054L121.426 115.853C120.481 115.348 120.106 114.185 120.58 113.223C121.024 112.31 122.086 111.879 123.041 112.223L136.263 116.99L134.876 123.054Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M129.359 133.783L134.906 116.535L146.635 120.044L154.98 129.271L140.084 141.11C135.84 140.262 132.097 137.785 129.657 134.21L129.359 133.783Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M140.088 141.126C135.844 140.278 132.101 137.801 129.661 134.226L129.359 133.783L132.029 125.25"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M146.633 120.06L154.978 129.287"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M149.707 133.481L138.574 118.585C137.417 117.028 137.71 114.832 139.237 113.634L140.134 112.917L154.999 129.287L149.707 133.481Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M154.984 129.287L140.119 112.917L139.241 113.634C137.726 114.837 137.441 117.027 138.598 118.577L141.793 122.854C141.793 122.854 136.391 125.99 136.752 133.893"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M132.089 121.565L121.426 115.853C120.481 115.348 120.106 114.185 120.58 113.223C121.024 112.31 122.086 111.879 123.041 112.223L138.078 117.574"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M85.6883 87.1797C86.6026 84.9983 89.1121 83.9711 91.2935 84.8854L204.589 132.371C206.771 133.285 207.798 135.795 206.884 137.976C205.969 140.158 203.46 141.185 201.279 140.271L87.9826 92.7848C85.8012 91.8706 84.774 89.361 85.6883 87.1797Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M195.523 108.007L198.528 109.266L187.886 134.656L184.882 133.397L195.523 108.007Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M35.2557 66.4092C37.0604 62.1034 42.014 60.0758 46.3198 61.8805L178.741 117.382C183.047 119.187 185.074 124.14 183.269 128.446C181.465 132.752 176.511 134.779 172.205 132.975L39.7844 77.4732C35.4786 75.6685 33.451 70.715 35.2557 66.4092Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M42.7803 53.1261L158.426 101.597C164.249 104.037 166.99 110.735 164.55 116.557L161.71 123.333C159.27 129.155 152.572 131.896 146.75 129.456L31.1036 80.9855L42.7803 53.1261V53.1261Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M100.536 99.0168L107.349 82.8116C107.605 82.2051 107.609 81.5216 107.359 80.9124C107.11 80.3032 106.628 79.8186 106.02 79.5658L102.261 77.9978C103.668 74.6423 107.482 76.0888 110.838 77.496L115.722 79.5423C117.335 80.2166 118.613 81.5047 119.275 83.1225C119.937 84.7403 119.928 86.555 119.25 88.1663L109.552 111.294C108.877 112.906 107.589 114.184 105.971 114.846C104.354 115.507 102.54 115.499 100.928 114.822L94.7856 112.247C91.4301 110.84 89.1682 109.193 90.5716 105.838L93.7625 107.174C95.2639 107.801 96.9897 107.101 97.6315 105.606L100.536 99.0168Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M195.039 114.927L201.901 117.803L195.976 131.939L189.114 129.063L195.039 114.927Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M53.4633 74.2818C57.0305 65.7715 57.5284 57.7276 54.804 55.3403L54.8432 55.2463L54.4943 55.1012C54.2037 54.902 53.8734 54.7683 53.5261 54.7092L31.1429 45.3169L17.1406 78.7349L40.8449 88.6721L40.9076 88.531C44.5101 88.7897 49.9001 82.7921 53.4633 74.2818Z"
        fill="white"
        stroke="#1D2B47"
      />
      <ellipse
        cx="23.257"
        cy="61.8951"
        rx="18.1321"
        ry="6.98412"
        transform="rotate(-67.0273 23.257 61.8951)"
        fill="#2B5FCE"
        stroke="#1D2B47"
      />
      <circle
        cx="111.848"
        cy="114.881"
        r="9.12968"
        fill="white"
        stroke="#1D2B47"
      />
      <circle
        cx="111.851"
        cy="114.881"
        r="4.17088"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M194.227 104.45L194.466 107.484C194.551 108.59 195.221 109.566 196.222 110.044L197.351 110.581C198.351 111.06 199.531 110.968 200.444 110.338L202.952 108.617L194.227 104.45Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M197.003 129.55C195.933 121.812 200.954 118.272 200.954 118.272L197.426 114.352C196.154 112.935 196.236 110.765 197.61 109.448L198.43 108.664L205.901 113.838C207.378 114.864 208.461 116.363 208.971 118.088L214.721 133.682"
        fill="#EEC493"
      />
      <path
        d="M197.003 129.55C195.933 121.812 200.954 118.272 200.954 118.272L197.426 114.352C196.154 112.935 196.236 110.765 197.61 109.448L198.43 108.664L205.901 113.838C207.378 114.864 208.461 116.363 208.971 118.088L214.721 133.682"
        stroke="#1D2B47"
      />
      <path
        d="M196.603 119.017L182.119 115.042C181.095 114.764 180.478 113.722 180.727 112.69C180.956 111.716 181.882 111.07 182.875 111.193L199.731 113.125L196.603 119.017Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M272.666 228.361H239.091C238.215 228.364 237.377 228 236.781 227.357C236.186 226.714 235.886 225.852 235.955 224.978L236.59 216.829C236.717 215.192 238.085 213.931 239.726 213.936H272.654L272.666 228.361Z"
        fill="#2B5FCE"
        stroke="#1D2B47"
      />
      <path
        d="M272.664 226.217L285.961 143.383C285.961 143.383 275.769 136.825 251.927 154.653C247.133 169.941 242.57 192.544 240.32 213.935H272.664V226.217Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M238.959 228.353C234.647 279.838 235.62 332.284 235.62 332.284L204.852 350.394L265.588 351.813L268.991 248.427L272.307 228.361H239.089L238.959 228.353Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M317.292 205.594L272.738 228.471C260.194 196.719 260.954 161.329 260.954 161.329L289.794 142.709L302.863 158.448C307.439 163.643 310.534 169.972 311.824 176.774L317.292 205.594Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M296.78 204.398C292.723 193.061 287.313 169.98 287.313 169.98C287.313 169.98 279.865 172.913 277.172 165.7"
        fill="white"
      />
      <path
        d="M296.78 204.398C292.723 193.061 287.313 169.98 287.313 169.98C287.313 169.98 279.865 172.913 277.172 165.7"
        stroke="#1D2B47"
      />
      <path
        d="M272.663 226.217L272.307 228.361H272.663V226.217Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M325.632 216.413L320.901 201.764C320.136 198.361 318.255 197.303 314.946 198.397L267.93 213.936C267.93 213.936 272.214 229.937 274.692 230.615C277.169 231.293 283.257 236.476 283.257 236.476"
        fill="#2B5FCE"
      />
      <path
        d="M325.632 216.413L320.901 201.764C320.136 198.361 318.255 197.303 314.946 198.397L267.93 213.936C267.93 213.936 272.214 229.937 274.692 230.615C277.169 231.293 283.257 236.476 283.257 236.476"
        stroke="#1D2B47"
      />
      <path
        d="M321.608 222.991C324.853 221.722 326.46 218.066 325.198 214.817C324.591 213.257 323.388 212.002 321.856 211.329C320.323 210.656 318.585 210.619 317.025 211.227L309.859 214.018L311.721 226.84L321.608 222.991Z"
        fill="#1A1C35"
        stroke="#1D2B47"
      />
      <path
        d="M382.882 306.8L313.032 235.919L311.715 226.84L309.853 214.018L272.734 228.471C274.275 232.403 276.034 236.247 278.003 239.984C280.932 245.606 284.476 250.887 288.567 255.73C318.426 290.618 350.895 317.858 350.895 317.858L344.11 346.921L382.882 306.8Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path d="M256.43 213.935L259.515 180.568L256.43 213.935Z" fill="white" />
      <path d="M256.43 213.935L259.515 180.568" stroke="#1D2B47" />
      <path
        d="M267.748 351.018L267.525 327.792C267.497 325.013 265.285 322.749 262.507 322.657L257.152 322.48C255.037 322.414 253.121 321.216 252.135 319.344L250.524 316.263C249.723 314.724 248.139 313.75 246.404 313.731L239.638 313.644C238.329 313.628 237.072 314.157 236.17 315.106C235.267 316.054 234.801 317.336 234.883 318.642V318.689C235.432 327.047 231.355 333.28 223.715 337.2C215.004 341.669 205.706 342.547 207.517 351.896C208.533 357.117 267.748 351.018 267.748 351.018Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M267.703 353.009C267.703 353.009 221.373 357.627 206.551 353.758C205.434 353.487 204.692 352.427 204.819 351.284C204.972 350.038 205.117 348.603 205.117 348.603C205.117 348.603 206.383 343.315 218.104 339.485C223.854 337.603 221.11 344.898 227.794 346.933C234.728 349.034 267.692 344.679 267.692 344.679L267.703 353.009Z"
        fill="white"
        stroke="#1D2B47"
      />
      <ellipse
        cx="255.044"
        cy="332.841"
        rx="4.88824"
        ry="4.73536"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M246.587 319.003C246.587 319.003 248.155 331.265 228.72 341.896C224.483 344.506 216.96 344.738 216.086 347.952"
        stroke="#1D2B47"
      />
      <path
        d="M226.539 332.989C226.539 332.989 229.871 331.813 231.306 335.584"
        stroke="#1D2B47"
      />
      <path
        d="M228.641 330.579C228.641 330.579 231.973 329.403 233.407 333.17"
        stroke="#1D2B47"
      />
      <path
        d="M230.75 328.184C230.75 328.184 234.082 327.008 235.517 330.775"
        stroke="#1D2B47"
      />
      <path
        d="M227.167 328.427C227.167 328.427 223.423 319.105 220.797 321.978C218.17 324.852 223.2 329.034 223.709 327C224.219 324.965 219.37 323.299 217.437 325.741C215.505 328.184 221.291 330.332 225.947 330.206"
        stroke="#1D2B47"
      />
      <path
        d="M263.223 191.438C263.223 191.438 260.557 209.862 262.215 228.353H272.662C272.662 228.353 265.461 207.624 263.223 191.438Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M226.925 105.814C235.032 99.5811 244.036 100.326 253.789 107.441L281.025 124.128C284.187 126.068 286.455 129.177 287.337 132.78L289.767 142.787L247.274 173.003L229.611 169.98L219.242 133.693"
        fill="white"
      />
      <path
        d="M226.925 105.814C235.032 99.5811 244.036 100.326 253.789 107.441L281.025 124.128C284.187 126.068 286.455 129.177 287.337 132.78L289.767 142.787L247.274 173.003L229.611 169.98L219.242 133.693"
        stroke="#1D2B47"
      />
      <path
        d="M226.055 157.201L230.669 170.161L236.98 171.242L286.987 131.584C285.931 128.482 283.823 125.847 281.029 124.136L273.479 119.51L226.055 157.201Z"
        fill="#B99BF9"
        stroke="#1D2B47"
      />
      <path
        d="M226.925 105.814C235.032 99.5811 244.036 100.326 253.789 107.441L281.025 124.128C284.187 126.068 286.455 129.177 287.337 132.78L289.767 142.787L247.274 173.003L229.611 169.98L219.242 133.693"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M289.791 142.709C289.791 142.709 292.39 143.999 294.221 147.538C294.552 148.177 294.388 148.96 293.829 149.412C282.23 158.734 251.693 181.25 251.693 181.25L250.125 170.431L289.791 142.709Z"
        fill="white"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M235.823 171.227L208.956 123.529L192.617 133.011L213.715 180.4L215.243 183.536C218.618 190.466 224.999 195.452 232.539 197.051C240.079 198.65 247.935 196.684 253.832 191.721C253.832 191.721 269.461 176.657 257.18 133.058C242.723 107.367 229.591 106.732 228.611 111.432C227.631 116.132 235.823 171.227 235.823 171.227Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M195.805 148.703C195.801 149.801 196.039 150.886 196.502 151.882L210.795 182.427L212.312 185.543C219.442 200.184 242.229 204.469 253.832 191.701C253.832 191.701 272.433 173.814 257.784 120.844C256.58 114.509 256.043 121.471 253.276 118.139C242.586 105.269 229.395 107.696 228.611 111.432C227.627 116.136 235.828 171.227 235.828 171.227L223.703 141.22C223.148 139.841 222.192 138.662 220.959 137.833L214.648 133.615L195.86 140.279L195.805 148.703Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M229.521 124.571C231.516 142.294 235.824 171.219 235.824 171.219L223.699 141.212C223.144 139.834 222.189 138.654 220.955 137.825L214.644 133.607L195.856 140.271L195.813 148.711C195.809 149.809 196.047 150.894 196.51 151.89L210.803 182.435L212.32 185.551C219.45 200.192 242.237 204.477 253.84 191.709C253.84 191.709 267.258 177.88 262.523 144.52C262.523 144.52 260.171 126.018 257.282 118.813"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M96.1406 299.102L117.168 314.891L141.181 298.004"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M187.453 128.715L197.049 113.693L205.187 118.989L213.717 131.953L195.826 138.393C191.997 136.524 189.053 133.228 187.626 129.213L187.453 128.715Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M192.801 118.049L182.119 115.042C181.095 114.764 180.478 113.722 180.727 112.69C180.956 111.716 181.882 111.07 182.875 111.193L200.213 113.235"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M195.05 121.898L177.931 115.936C176.933 115.587 176.399 114.501 176.732 113.497C177.044 112.558 178.015 112.005 178.982 112.216L196.23 115.987L195.05 121.898Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M190.401 120.279L177.931 115.936C176.933 115.587 176.399 114.501 176.732 113.497C177.044 112.558 178.015 112.005 178.982 112.216L197.406 116.057"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M193.667 126.994L188.995 124.885L186.745 123.87L177.148 119.534C176.183 119.099 175.747 117.969 176.168 116.998C176.562 116.091 177.577 115.627 178.52 115.924L195.361 121.208L193.667 126.994Z"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M188.297 124.571L186.729 123.87L177.133 119.534C176.168 119.099 175.731 117.969 176.153 116.998C176.547 116.091 177.561 115.627 178.505 115.924L195.357 121.208"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M195.846 138.511C191.999 136.598 189.047 133.263 187.614 129.213L187.438 128.715"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M188.626 128.401L177.45 125.343C176.445 125.027 175.87 123.972 176.148 122.956C176.422 122.005 177.369 121.413 178.343 121.584L191.279 123.936"
        fill="#EEC493"
      />
      <path
        d="M188.626 128.401L177.45 125.343C176.445 125.027 175.87 123.972 176.148 122.956C176.422 122.005 177.369 121.413 178.343 121.584L191.279 123.936"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M217.467 115.531C215.746 113.237 216.211 109.983 218.505 108.262L225.028 103.37C227.322 101.65 230.576 102.114 232.297 104.408C234.017 106.702 233.553 109.957 231.259 111.677L224.736 116.569C222.442 118.29 219.187 117.825 217.467 115.531Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M219.05 117.554L215.847 113.289C215.013 112.176 215.239 110.596 216.353 109.761L227.133 101.667C228.247 100.836 229.822 101.06 230.661 102.168L233.863 106.433"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M193.145 93.1229L200.674 87.9584L206.661 96.6862L199.132 101.851C196.72 103.505 193.424 102.891 191.769 100.479C190.115 98.0675 190.729 94.771 193.141 93.1165L193.145 93.1229Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M216.509 89.1187L229.598 105.01L221.495 116.312L207.344 95.6807"
        fill="#EEC493"
      />
      <path
        d="M216.509 89.1187L229.598 105.01L221.495 116.312L207.344 95.6807"
        stroke="#1D2B47"
      />
      <path
        d="M221.491 116.312L207.336 95.6812"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M216.508 89.1187L229.597 105.01"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M212.148 102.666C212.148 102.666 215.116 101.016 216.268 98.311C217.879 101.839 216.092 108.413 216.092 108.413L212.148 102.666Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <circle
        cx="209.23"
        cy="94.2461"
        r="8.90232"
        fill="#EEC493"
        stroke="#1D2B47"
      />
      <path
        d="M216.745 99.0249C214.81 102.083 211.217 103.666 207.654 103.03C204.092 102.394 201.268 99.6657 200.51 96.1271C199.753 92.5886 201.211 88.9433 204.201 86.9043"
        stroke="#1D2B47"
        strokeLinecap="round"
      />
      <path
        d="M221.972 95.4848C221.972 95.4848 217.244 97.3586 213.614 92.4704C215.394 89.8832 211.858 87.1156 210.565 88.8208C209.271 90.526 212.133 94.3088 212.133 94.3088C212.133 94.3088 209.44 93.9717 207.064 89.3148L199.824 94.2775C196.282 96.707 191.475 96.0505 188.715 92.7604C188.564 92.5851 188.423 92.4019 188.291 92.2116L188.26 92.1646C188.251 92.1493 188.24 92.1349 188.229 92.1215C186.797 89.9431 186.883 87.1015 188.443 85.0132C190.003 82.9249 192.703 82.0369 195.198 82.7919C194.548 79.8927 196.045 76.9395 198.768 75.7506C201.491 74.5618 204.675 75.4713 206.359 77.9193C206.468 78.084 206.292 77.8292 206.664 78.4211C207.571 75.679 210.404 74.0667 213.224 74.6879C216.045 75.3092 217.939 77.9627 217.609 80.8319C217.609 80.8319 220.718 80.1616 222.948 84.1404C225.378 88.4994 221.972 95.4848 221.972 95.4848Z"
        fill="#B99BF9"
        stroke="#1D2B47"
      />
      <path
        d="M216.984 112.051C216.984 112.051 224.875 109.346 229.136 102.812C230.038 104.164 232.743 106.869 232.743 106.869C232.743 106.869 224.178 117.688 222.602 118.139C221.026 118.59 216.984 112.051 216.984 112.051Z"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M216.984 112.051C216.984 112.051 224.875 109.346 229.136 102.812"
        stroke="#1D2B47"
      />
      <path
        d="M196.616 112.776C196.347 111.571 196.728 110.314 197.619 109.46L198.439 108.676L205.91 113.85C207.387 114.876 208.47 116.375 208.98 118.099L214.73 133.693"
        stroke="#1D2B47"
      />
      <path d="M194.82 137.958L195.796 140.228" stroke="#1D2B47" />
      <path d="M222.598 139.546L203.688 146.767" stroke="#1D2B47" />
      <path d="M169.423 137.578L152.523 150.824" stroke="#1D2B47" />
      <path d="M230.289 105.065L232.026 107.798" stroke="#1D2B47" />
      <path d="M219.695 113.631L221.432 116.363" stroke="#1D2B47" />
      <path d="M223.078 112.501L224.815 115.234" stroke="#1D2B47" />
      <path d="M228.258 108.444L229.994 111.177" stroke="#1D2B47" />
      <path d="M226 111.149L227.737 113.882" stroke="#1D2B47" />
      <path d="M286.984 144.775L291.982 150.886" stroke="#1D2B47" />
      <path d="M282.023 148.381L287.021 154.493" stroke="#1D2B47" />
      <path d="M277.062 151.988L282.061 158.099" stroke="#1D2B47" />
      <path d="M271.984 155.449L277.171 161.866" stroke="#1D2B47" />
      <path d="M267.023 158.71L272.433 165.7" stroke="#1D2B47" />
      <path d="M263.422 164.12L267.479 169.306" stroke="#1D2B47" />
      <rect
        x="237.273"
        y="317.847"
        width="6.08776"
        height="2.7048"
        rx="1.3524"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M384.876 307.51L368.749 290.768C366.821 288.765 363.657 288.639 361.576 290.482L357.565 294.01C355.977 295.414 353.756 295.854 351.752 295.162L348.467 294.025C346.827 293.457 345.006 293.838 343.732 295.017L338.773 299.619C337.802 300.51 337.25 301.767 337.25 303.085C337.25 304.402 337.802 305.659 338.773 306.55L338.808 306.581C344.951 312.273 346.256 319.592 343.395 327.69C340.129 336.918 333.987 343.943 341.709 349.493C346.009 352.602 384.876 307.51 384.876 307.51Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M386.202 308.976C386.202 308.976 355.693 344.15 342.27 351.504C341.271 352.072 340.006 351.812 339.311 350.897C338.566 349.885 337.684 348.741 337.684 348.741C337.684 348.741 334.975 344.037 340.867 333.198C343.756 327.879 346.771 335.068 353.019 331.948C359.503 328.714 380.459 302.916 380.459 302.916L386.202 308.976Z"
        fill="white"
        stroke="#1D2B47"
      />
      <ellipse
        cx="363.141"
        cy="302.986"
        rx="4.88824"
        ry="4.73536"
        transform="rotate(-43.37 363.141 302.986)"
        fill="white"
        stroke="#1D2B47"
      />
      <path
        d="M347.504 298.784C347.504 298.784 357.057 306.624 350.248 327.69C348.962 332.496 343.643 337.812 345.207 340.756"
        stroke="#1D2B47"
      />
      <path
        d="M342.531 322.696C342.531 322.696 344.138 319.56 347.776 321.308"
        stroke="#1D2B47"
      />
      <path
        d="M342.406 319.501C342.406 319.501 344.013 316.346 347.651 318.114"
        stroke="#1D2B47"
      />
      <path
        d="M342.297 316.303C342.297 316.303 343.9 313.147 347.542 314.915"
        stroke="#1D2B47"
      />
      <path
        d="M339.856 318.949C339.856 318.949 330.731 314.743 330.797 318.635C330.864 322.528 337.375 322.104 336.36 320.289C335.344 318.474 330.668 320.576 330.946 323.668C331.225 326.761 336.901 324.358 340.201 321.07"
        stroke="#1D2B47"
      />
      <path
        d="M340.858 305.272C340.345 304.729 340.37 303.873 340.913 303.36L343.372 301.037C343.915 300.524 344.771 300.548 345.284 301.091C345.797 301.634 345.772 302.49 345.229 303.003L342.77 305.326C342.227 305.839 341.371 305.815 340.858 305.272Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
    </svg>
  )
}
